import React from "react";
import { Link } from "react-router-dom";

export const ButtonPrimary = ({ href, onclick, children, style }) => {
  const buttonElement = (
    <button
      className="outline-none bg-primary border disabled:bg-[#ABB6AC] border-primary text-white font-medium text-sm leading-5 py-[10px] px-[20px] rounded-[8px]  hover:border hover:border-primary  transition ease-in-out delay-100"
      onClick={onclick}
      style={style}
    >
      {children}
    </button>
  );

  return (
    <div>
      {href ? (
        <Link to={href}>
          {buttonElement}
        </Link>
      ) : (
        buttonElement
      )}
    </div>
  );
};

export const ButtonSecondary = ({ href, onclick, children }) => {
  const buttonElement = (
    <button
      className="outline-none bg-white border border-primary text-primary font-medium text-sm leading-5 py-[10px] px-[20px] rounded-[8px] hover:border hover:border-primary transition ease-in-out delay-100"
      onClick={onclick}
    >
      {children}
    </button>
  );

  return (
    <div>
      {href ? (
        <Link to={href}>
          {buttonElement}
        </Link>
      ) : (
        buttonElement
      )}
    </div>
  );
};

export const ButtonTertiary = ({ href, onclick, children }) => {
  const buttonElement = (
    <button
      className="outline-none bg-white border border-transparent text-primary font-medium text-sm leading-5 py-[10px] px-[20px] rounded-[8px] hover:border hover:border-primary transition ease-in-out delay-100"
      onClick={onclick}
    >
      {children}
    </button>
  );

  return (
    <div>
      {href ? (
        <Link to={href}>
          {buttonElement}
        </Link>
      ) : (
        buttonElement
      )}
    </div>
  );
};
